import settings from './settings.module'
export default settings
